import React, { useEffect, useState } from "react";
import { app } from "@microsoft/teams-js";
import { useRef } from "react";
import Toggle from "./toggle/Toggle";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import { useSSOAuth } from "./SSOAuthService";
import { getApiBaseUrl, parseJwt } from "./PresenceSubscriptionCard";
import "./Setting.css";

const REQUIRED_GRAPH_SCOPES = ['User.Read.All', 'Presence.Read.All', 'Calendars.Read'];
const SSO_SCOPES = ['User.Read.All', 'Presence.Read.All', 'Calendars.Read', 'offline_access'];

const hasAllScopes = (token, required) => {
    const decoded = parseJwt(token);
    const scp = (decoded && decoded.scp) ? decoded.scp.split(' ') : [];
    return required.every(s => scp.includes(s));
};

// CRM-3541: remember which ebuero user_account_id this Teams tab last signed in as,
// keyed by the MS Teams aad_id. Lets us disambiguate on re-mount when one aad_id
// has been paired with multiple ebuero users.
const storedAccountIdKey = (aadId) => `msteams:${aadId}:user_account_id`;
const getStoredUserAccountId = (aadId) => {
    try { return window.localStorage.getItem(storedAccountIdKey(aadId)); } catch (e) { return null; }
};
const setStoredUserAccountId = (aadId, userAccountId) => {
    try { window.localStorage.setItem(storedAccountIdKey(aadId), String(userAccountId)); } catch (e) { /* ignore */ }
};
const clearStoredUserAccountId = (aadId) => {
    try { window.localStorage.removeItem(storedAccountIdKey(aadId)); } catch (e) { /* ignore */ }
};

function SyncStatusPill({ value }) {
    let color, bg, label;
    if (value === true) {
        color = '#107c10'; bg = 'rgba(16, 124, 16, 0.08)'; label = 'Aktiv';
    } else if (value === false) {
        color = '#888'; bg = 'rgba(136, 136, 136, 0.08)'; label = 'Nicht konfiguriert';
    } else {
        color = '#888'; bg = 'rgba(136, 136, 136, 0.08)'; label = '—';
    }
    return (
        <div className="status-pill" style={{ backgroundColor: bg, color }}>
            <span className="status-dot" style={{ backgroundColor: color }} />
            Mitarbeiter-Sync: {label}
        </div>
    );
}

function PresenceStatusPill({ value }) {
    let color, bg, label;
    if (value === 'Active') {
        color = '#107c10'; bg = 'rgba(16, 124, 16, 0.08)'; label = 'Aktiv';
    } else if (value === 'Expired') {
        color = '#F7A827'; bg = 'rgba(247, 168, 39, 0.08)'; label = 'Abgelaufen';
    } else if (value === 'Inactive') {
        color = '#888'; bg = 'rgba(136, 136, 136, 0.08)'; label = 'Inaktiv';
    } else {
        color = '#888'; bg = 'rgba(136, 136, 136, 0.08)'; label = '—';
    }
    return (
        <div className="status-pill" style={{ backgroundColor: bg, color }}>
            <span className="status-dot" style={{ backgroundColor: color }} />
            Präsenz-Abonnement: {label}
        </div>
    );
}

function Setting() {
    const history = useHistory();
    const [isInitialize, setIsInitialize] = useState(true);
    const [loading, setLoading] = useState(false);
    const [context, setContext] = useState(null);
    const [user, setUser] = useState(null);
    const [dayPlanToggleValue, setDayPlanToggleValue] = useState(false);
    const [dayPlanDisableValue, setDayPlanDisableValue] = useState(false);
    const { user: ssoUser, loading: ssoLoading, error: ssoError, login: ssoLogin, loginWithConsent: ssoLoginWithConsent, getToken: ssoGetToken } = useSSOAuth();
    const [showSignOutConfirm, setShowSignOutConfirm] = useState(false);
    const [syncStatus, setSyncStatus] = useState(null);
    const [presenceStatus, setPresenceStatus] = useState(null);

    const usernameInput = useRef(null);
    const passwordInput = useRef(null);
    const [shouldLogin, setShouldLogin] = useState(false);
    const [infoloading, setInfoLoading] = useState(false);
    const [isDisabledSubscribe, setDisabledSubscribe] = useState(false);
    const [isDisabledUnsubscribe, setDisabledUnsubscribe] = useState(false);



    useEffect(() => {
        async function getUserData() {
            await app.initialize();
            app.notifyAppLoaded();
            console.log(process.env.REACT_APP_ENV);
            console.log("In get user data");
            const context = await app.getContext();
            setContext(context);
            console.log("debug context", context);

            // CRM-3541: one MS aad_id can be paired with multiple ebuero user_account_ids.
            // Auto-recovery requires the stored user_account_id; without it we can't tell
            // which row belongs to this tab session. Explicit sign-out clears the stored
            // id (server-side status stays Active so background jobs keep running), so
            // falling through to sign-in here is how sign-out "sticks".
            const storedAccountId = getStoredUserAccountId(context.user.id);
            if (!storedAccountId) {
                console.log("no stored user_account_id; showing sign-in");
                setInfoLoading(false);
                setIsInitialize(false);
                app.notifySuccess();
                return;
            }
            const user = await getUserByAccount(context.user.id, storedAccountId);
            // If the stored account is no longer the Active one (e.g. another ebuero
            // user signed in from the same MS identity on a different machine), force
            // re-login rather than silently showing stale data.
            if (user && user.status && user.status !== 'Active') {
                clearStoredUserAccountId(context.user.id);
                console.log("stored account is Inactive; forcing sign-in");
                setInfoLoading(false);
                setIsInitialize(false);
                app.notifySuccess();
                return;
            }
            console.log("out from getiUser" + user);
            setInfoLoading(false);
            if (user != null) {
                //Check expired tocken
                const timestampInSeconds = Math.floor(Date.now() / 1000);
                console.log(timestampInSeconds);

                const check_expire = user.token_expires_at - timestampInSeconds;
                console.log(check_expire);
                if ((user.token == "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx") || ((check_expire < 0) && ((user.call_note_webhook_id == null)) || (user.call_note_webhook_id == '')))
                    user.token = null;
            }

            console.log("Before Set User State:" + user);
            setUser(user);
            /*
            if (user) {
                setDayPlanToggleValue(
                    user.graph_subscription_id && user.graph_subscription_id.length > 0
                );
            }
            */
            console.log("debug user", user);

            setIsInitialize(false);
            app.notifySuccess();
        }

        getUserData();
    }, []);

    useEffect(() => {
        if (!context) return;
        async function fetchStatusData() {
            try {
                const token = await ssoGetToken(['User.Read.All']);
                const decoded = parseJwt(token);
                const tenantId = decoded?.tid;
                if (!tenantId) return;
                const baseUrl = getApiBaseUrl();
                const headers = { Authorization: `Bearer ${token}`, Accept: 'application/json' };
                const [syncRes, presenceRes] = await Promise.all([
                    fetch(`${baseUrl}/MSTeamsUser/syncConfig/${tenantId}`, { headers }),
                    fetch(`${baseUrl}/MSTeamsUser/presenceSubscriptionStatus/${tenantId}`, { headers }),
                ]);
                if (syncRes.ok) {
                    const data = await syncRes.json();
                    setSyncStatus(Boolean(data.setupComplete));
                }
                if (presenceRes.ok) {
                    const data = await presenceRes.json();
                    setPresenceStatus(data.status || null);
                }
            } catch (e) {
                console.error('Failed to fetch status data', e);
            }
        }
        fetchStatusData();
    }, [context]);

    async function refreshToken(username, password, device_id) {
        setLoading(true);

        try {
            const tokenData = await getToken(username, password, device_id);
            console.log(tokenData);

            const user = await updateToken(tokenData);
            setUser(user);
            console.log("update token user", user);

            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }

    async function login(username, password, device_id) {
        setLoading(true);

        try {
            const tokenData = await getToken(username, password, device_id);
            console.log(tokenData);

            const userDetailData = await getUserDetail(tokenData);
            console.log(userDetailData);

            const phoneServiceData = await getPhoneService(
                tokenData,
                userDetailData
            );
            console.log(phoneServiceData);

            const user = await createUser(
                userDetailData,
                phoneServiceData,
                tokenData
            );
            setUser(user);
            console.log("create user", user);
            console.log("device id :" + device_id);
            //   Cookies.set('device_id', device_id, { domain: '.ebuero.de' });
            // document.cookie = `access_token=${tokenData.access_token};expires=Session;SameSite=Lax`;
            // localStorage.setItem("device_id", device_id);
            // localStorage.setItem("access_token", tokenData.access_token);
            // localStorage.setItem("expires_in", tokenData.expires_in);
            // Cookies.set('device_id', device_id, { domain: '.ebuero.de' });
            // Cookies.set('access_token', tokenData.access_token, { domain: '.ebuero.de' });
            //  Cookies.set('expires_in', tokenData.expires_in, { domain: '.ebuero.de' });
            console.log(document.cookie);
            // console.log(document.location.href);
            document.cookie = `device_id=${device_id};SameSite=None;Secure;domain=.ebuero.de`;
            document.cookie = `access_token=${tokenData.access_token};SameSite=None;Secure`;
            document.cookie = `expires_in=${tokenData.expires_in};SameSite=None;Secure`;

            sendWelcomeLogin(user);

            setLoading(false);
            setShouldLogin(false);
        } catch (error) {
            console.error(error);
            //setLoading(false);

        }
    }

    async function getToken(username, password, device_id) {
        if (process.env.REACT_APP_AUTH_MODE === 'direct') {
            // Direct call for dev/test/local — secrets acceptable in bundle
            const clientId = process.env.REACT_APP_EBUERO_OAUTH_CLIENT_ID;
            const clientSecret = process.env.REACT_APP_EBUERO_OAUTH_CLIENT_SECRET;

            const response = await fetch(
                `${process.env.REACT_APP_REST_API}/authorization/v1/oauth/token`,
                {
                    method: "POST",
                    headers: {
                        Authorization: "Basic " + btoa(`${clientId}:${clientSecret}`),
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: new URLSearchParams({
                        grant_type: "password",
                        username,
                        password,
                        device_id,
                    }).toString(),
                }
            );

            if (!response.ok) {
                setInfoLoading(true);
                throw new Error("Unable to login directly");
            }
            return await response.json();
        }

        // Proxy mode for stage/prod
        const botUrl = process.env.REACT_APP_BOT_URL;
        const response = await fetch(`${botUrl}/api/ebuero/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username, password, device_id })
        });

        if (!response.ok) {
            setInfoLoading(true);
            throw new Error("Unable to login via Proxy");
        }

        return await response.json();
    }

    async function getUserDetail(tokenData) {
        const response = await fetch(`${process.env.REACT_APP_REST_API}/authorization/v1/userdetails`, {
            method: "GET",
            headers: { Authorization: `${tokenData.token_type} ${tokenData.access_token}` }
        });

        if (!response.ok) throw new Error("Unable to get user detail");
        return await response.json();
    }

    async function getPhoneService(tokenData, userDetailData) {
        const response = await fetch(`${process.env.REACT_APP_REST_API}/phoneservice/v3/phoneservices?userAccountId=${userDetailData.userId}`, {
            method: "GET",
            headers: { Authorization: `${tokenData.token_type} ${tokenData.access_token}` }
        });

        if (!response.ok) throw new Error("Unable to get phoneservice");
        const phoneServiceData = await response.json();
        return phoneServiceData.length > 0 ? phoneServiceData[0] : null;
    }

    async function createUser(userDetailData, phoneServiceData, tokenData) {
        const sumExpires = getTimestampInSeconds() + tokenData.expires_in;
        let germanFirstName = userDetailData.firstname.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        let germanLastName = userDetailData.lastname.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const requestBody = JSON.stringify({
            login: userDetailData.login,
            email: userDetailData.email,
            firstname: germanFirstName,
            lastname: germanLastName,
            aad_id: context.user.id,
            user_account_id: userDetailData.userId,
            phone_service_id: phoneServiceData.id,
            token: tokenData.access_token,
            token_expires_at: sumExpires,
            brand_id: phoneServiceData.brandId,
        });

        const userResponse = await fetch(
            `${process.env.REACT_APP_TSCM_URL}/MSTeamsUser/CreateMSTeamsUser/${context.user.id}`,
            {
                method: "POST",
                body: requestBody,
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }
        );

        if (!userResponse.ok) {
            throw new Error("Unable create user");
        }

        const userData = await userResponse.json();
        // CRM-3541: remember this ebuero account so re-mounts fetch the same row.
        setStoredUserAccountId(context.user.id, userDetailData.userId);
        const user = await getUserByAccount(context.user.id, userDetailData.userId);
        return user;
    }

    async function updateToken(tokenData) {
        let url = new URL(
            `${process.env.REACT_APP_TSCM_URL}/MSTeamsUser/UpdateMSTeamsUserToken/${user.aad_id}`
        );
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const sumExpires = getTimestampInSeconds() + tokenData.expires_in;
        const requestBody = JSON.stringify({
            token: tokenData.access_token,
            token_expires_at: sumExpires,
            user_account_id: user.user_account_id,
        });
        console.log(url);
        console.log("request body:" + requestBody);



        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: requestBody,
            redirect: 'follow'
        };

        const user_data = await fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => {
                //const users = JSON.parse(result);
                const user = JSON.parse(result);
                console.log(user);
                console.log(user.id);
                if (user.id == null) {
                    return null;
                } else {
                    console.log("update token user:" + user);
                    return user;
                }
            }
            )
            .catch(error => {
                console.log('error', error);
                return null;
            }
            );
        return user_data;

    }

    async function getUser(aadId) {
        let url = new URL(
            `${process.env.REACT_APP_TSCM_URL}/MSTeamsUser/GetMSTeamsUser/${aadId}`
        );
        console.log("sugar entry point:" + url);
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        const user_data = await fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => {
                console.log(result);
                //const users = JSON.parse(result);
                const user = JSON.parse(result);
                console.log(user);
                console.log(user.id);
                if (user.id == null) {
                    return null;
                } else {
                    console.log("get user:" + user);
                    //Check token expire
                    console.log("token:" + user.token_expires_at);


                    return user;
                }
            }
            )
            .catch(error => {
                console.log('error', error);
                return null;
            }
            );
        console.log("data user:" + user_data);
        return user_data;


    }

    // CRM-3541: mount/re-mount lookup scoped to the ebuero account we signed in as.
    // Returns the row regardless of status — caller must check `status === 'Active'`.
    async function getUserByAccount(aadId, userAccountId) {
        const url = new URL(
            `${process.env.REACT_APP_TSCM_URL}/MSTeamsUser/GetMSTeamsUserV2/${aadId}/${userAccountId}`
        );
        try {
            const response = await fetch(url, { method: 'GET', redirect: 'follow' });
            const text = await response.text();
            const parsed = JSON.parse(text);
            if (!parsed || parsed.id == null) return null;
            return parsed;
        } catch (error) {
            console.log('getUserByAccount error', error);
            return null;
        }
    }

    async function subscribeCallNote() {
        setDisabledSubscribe(true);
        //Check user account Id and aaid , No webhook


        let url = new URL(
            `${process.env.REACT_APP_TSCM_URL}/MSTeamsUser/CheckSubscribeCallNoteMSTeamsUser/${user.aad_id}/${user.user_account_id}`
        );
        console.log("sugar entry point:" + url);
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        const user_data = await fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => {
                console.log(result);
                //const users = JSON.parse(result);
                const user = JSON.parse(result);
                console.log(user);
                console.log(user.id);
                if (user.id == null) {
                    return null;
                } else {
                    console.log("get user:" + user);
                    //Check token expire
                    console.log("token:" + user.token_expires_at);


                    return user;
                }
            }
            )
            .catch(error => {
                console.log('error', error);
                setDisabledSubscribe(false);
                return null;
            }
            );
        console.log("subscribe user data:" + user_data);
        if ((user_data != null) && ((user_data.call_note_webhook_id == null) || (user_data.call_note_webhook_id == ''))) {
            try {
                const webhookData = await createCallNoteWebhook();
                console.log(webhookData);
                if (webhookData.error != "invalid_token") {
                    const userData = await sendSubscribeCallNote(webhookData);
                    setUser(userData);

                    console.log("update subscribe call note", userData);
                    sendWelcomeMessage(userData);
                } else {
                    console.log("in the sub call note");
                    setShouldLogin(true);
                }

            } catch (error) {
                console.error(error);
                setDisabledSubscribe(false);
            }
        }
    }

    async function unsubscribeCallNote() {
        setDisabledUnsubscribe(true);
        //Check user account Id and aaid , No webhook

        try {
            await deleteCallNoteWebhook();

            const userData = await sendUnsubscribeCallNote();
            setUser(userData);
            console.log("update unsubscribe call note", userData);

            sendUnsubscribeMessage(user);
            setDisabledSubscribe(false);
            setDisabledUnsubscribe(false);
        } catch (error) {
            console.error(error);
            try {
                const userData = await sendUnsubscribeCallNote();
                setUser(userData);
            } catch (innerError) {
                console.error("Failed to clear webhook ID in backend:", innerError);
            }
            setDisabledUnsubscribe(false);
        }
    }

    async function setTokenExpire() {
        let url = new URL(
            `${process.env.REACT_APP_TSCM_URL}/MSTeamsUser/UpdateMSTeamsUserToken/${user.aad_id}`
        );
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        // const sumExpires = getTimestampInSeconds() + tokenData.expires_in;
        const dateExpire = Math.floor((Date.now() - 1) / 1000);
        const tokenExpire = "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
        const requestBody = JSON.stringify({
            token: tokenExpire,
            token_expires_at: dateExpire,
            user_account_id: user.user_account_id,
        });



        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: requestBody,
            redirect: 'follow'
        };

        const user_data = await fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => {
                //const users = JSON.parse(result);
                const user = JSON.parse(result);
                console.log(user);
                console.log(user.id);
                if (user.id == null) {
                    return null;
                } else {
                    console.log("update token user:" + user);
                    user.token = null;
                    return user;
                }
            }
            )
            .catch(error => {
                console.log('error', error);
                return null;
            }
            );
        return user_data;

    }

    async function signOut() {
        // CRM-3541: record sign-out on the (aad_id, user_account_id) row only. Status
        // and tokens/webhooks are preserved server-side so background call-note and
        // presence jobs keep running. Forget the stored account so the next mount
        // shows the sign-in form instead of silently rehydrating this user.
        try {
            if (user && user.aad_id && user.user_account_id) {
                try {
                    await fetch(
                        `${process.env.REACT_APP_TSCM_URL}/MSTeamsUser/SignOutMSTeamsUser/${user.aad_id}/${user.user_account_id}`,
                        {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({}),
                            redirect: 'follow',
                        }
                    );
                } catch (e) {
                    console.log('SignOutMSTeamsUser failed (non-fatal)', e);
                }
            }
            if (context && context.user && context.user.id) {
                clearStoredUserAccountId(context.user.id);
            }
            setUser(null);
            setLoading(false);
            window.self.location.reload();
        } catch (error) {
            console.error(error);
        }
    }

    async function createCallNoteWebhook() {
        // webhook call note

        console.log("user in subscribe:" + user.phone_service_id + " acc:" + user.user_account_id);
        const webhookData = await fetch(`${process.env.REACT_APP_REST_API}/notification/v1/webhooks`, {
            method: "POST",
            headers: {
                Authorization: `bearer ${user.token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                name: "MS_TEAMS",
                notifictionTypes: ["PHONESERVICE"],
                phoneServiceId: user.phone_service_id,
                userAccountId: user.user_account_id,
                webhook: {
                    customHeaders:
                        "Cookie: ARRAffinity=53c1c349400039924ced224d57e501db160e6491f675b04cae81190b4e46b795; Cookie: ARRAffinitySameSite=53c1c349400039924ced224d57e501db160e6491f675b04cae81190b4e46b795",
                    url: `${process.env.REACT_APP_BOT_URL}/api/callnotes/${context.user?.id}`,
                    webhookStatus: "ACTIVE",
                },
            })
        }).then(response => response.text())
            .then(result => {
                console.log(result);
                const webhookResponses = JSON.parse(result);
                return webhookResponses;
            }
            )
            .catch(error => {
                console.log('error', error);
                return null;
            }
            );
        if ((webhookData == null) || (webhookData.error == "invalid_token")) {
            console.log("set should login");
            user.token = null;
            setShouldLogin(true);
        }
        return webhookData;




    }

    async function deleteCallNoteWebhook() {
        // webhook call note
        //Check expired token
        const timestampInSeconds = Math.floor(Date.now() / 1000);
        console.log(timestampInSeconds);

        const check_expire = user.token_expires_at - timestampInSeconds;
        console.log(check_expire);
        if (check_expire < 0) {
            user.token = null;
            setShouldLogin(true);
        } else {
            const webhookResponse = await fetch(`${process.env.REACT_APP_REST_API}/notification/v1/webhooks/${user.call_note_webhook_id}`, {
                method: "DELETE",
                headers: {
                    Authorization: `bearer ${user.token}`,
                    "Content-Type": "application/json",
                }
            });
            console.log(webhookResponse);

            if (!webhookResponse.ok && webhookResponse.status !== 404) {
                throw new Error("Unable to delete webhook");
            }
            return true;
        }

    }

    async function sendSubscribeCallNote(webhookData) {
        const requestBody = JSON.stringify({
            call_note_webhook_id: webhookData.id,
            user_account_id: user.user_account_id
        });

        let url = new URL(
            `${process.env.REACT_APP_TSCM_URL}/MSTeamsUser/SubscribeCallNoteMSTeamsUser/${user.aad_id}`
        );
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: requestBody,
            redirect: 'follow'
        };
        console.log(url);
        const user_data = await fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => {
                //const users = JSON.parse(result);
                const user = JSON.parse(result);
                console.log(user);
                console.log(user.id);
                if (user.id == null) {
                    return null;
                } else {
                    console.log("get user:", user);
                    return user;
                }
            }
            )
            .catch(error => {
                console.log('error', error);
                return null;
            }
            );
        return user_data;


    }

    async function sendUnsubscribeCallNote(webhookData) {

        const url = `${process.env.REACT_APP_TSCM_URL}/MSTeamsUser/UnSubscribeCallNoteMSTeamsUser/${user.aad_id}`;
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const requestBody = JSON.stringify({
            aad_id: user.aad_id,
            user_account_id: user.user_account_id
        });



        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: requestBody,
            redirect: 'follow'
        };
        console.log("unscribe sugar url:", url);
        const user_data = await fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => {
                // const users = JSON.parse(result);
                const user = JSON.parse(result);
                console.log(user);
                console.log(user.id);
                if (user.id == null) {
                    return null;
                } else {
                    console.log("get user in unscribe:" + user);
                    return user;
                }
            }
            )
            .catch(error => {
                console.log('error', error);
                return null;
            }
            );
        return user_data;
    }

    async function subscribeUserStatus() {
        const requestBody = new URLSearchParams({
            changeType: 'updated',
            clientState: 'ClientState',
            latestSupportedTlsVersion: "v1_2"
        }).toString();
        console.log(process.env.REACT_APP_BOT_URL);

        const subscribeDayplanResponse = await fetch(
            //    `${process.env.REACT_APP_BOT_URL}/api/subscribe-dayplan?aadid=` + user.aad_id,
            `http://localhost:3978/api/subscribe-dayplan?aadid=` + user.aad_id,
            {
                mode: "no-cors",
                method: "POST",
                body: requestBody,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        );
        await subscribeDayplanResponse
        // const subscribeStatus = await subscribeDayplanResponse.json();
        // return subscribeStatus.id
        return 123
    }

    async function unsubscribeUserStatus(graphWebhookId) {
        const unsubscribeDayplanResponse = await fetch(
            `${process.env.REACT_APP_BOT_URL}/api/unsubscribe-dayplan/` + graphWebhookId + `?aadid=` + user.aad_id,
            {
                method: "POST",
                mode: "no-cors",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        );
        return true
    }

    async function saveDayPlan(id, graphSubscriptionId) {
        const requestBody = new URLSearchParams({
            graph_subscription_id: graphSubscriptionId
        }).toString();
        await fetch(
            `${process.env.REACT_APP_TSCM_URL}/api/teams-app-users/${id}/day-plan/subscribe`,
            {
                method: "POST",
                body: requestBody,
                headers: {
                    Authorization: `Bearer ${process.env.REACT_APP_TSCM_TOKEN}`,
                    "Content-Type": "application/x-www-form-urlencoded",
                    Accept: "application/json",
                },
            }
        );
    }

    async function removeDayPlan(id) {
        const url =
            process.env.REACT_APP_TSCM_URL +
            `/api/teams-app-users/${id}/day-plan/unsubscribe`;
        await fetch(url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${process.env.REACT_APP_TSCM_TOKEN}`,
            },
        });
    }

    function sendWelcomeMessage(user) {
        const botUrl = process.env.REACT_APP_BOT_URL;
        console.log("welcome subscription entry point:" + botUrl);
        console.log(`user account:${user.user_account_id} aaid:${user.aad_id} user log in:${user.login} phone service id:${user.phone_service_id}`);
        fetch(`${botUrl}/api/welcomesubscription`, {
            method: "POST",
            mode: "no-cors",
            body: new URLSearchParams({
                userAccountId: user.user_account_id,
                aadid: user.aad_id,
                userName: user.login,
                phoneserviceId: user.phone_service_id,
            }).toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Access-Control-Allow-Origin": "*",
            },
        });
    }

    function sendWelcomeLogin(user) {
        const botUrl = process.env.REACT_APP_BOT_URL;
        console.log("welcome login entry point:" + botUrl);
        console.log(`user account:${user.user_account_id} aaid:${user.aad_id} user log in:${user.login} phone service id:${user.phone_service_id}`);
        fetch(`${botUrl}/api/welcomelogin`, {
            method: "POST",
            mode: "no-cors",
            body: new URLSearchParams({
                userAccountId: user.user_account_id,
                aadid: user.aad_id,
                userName: user.login,
                phoneserviceId: user.phone_service_id,
            }).toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Access-Control-Allow-Origin": "*",
            },
        });
    }

    function sendUnsubscribeMessage(user) {
        const botUrl = process.env.REACT_APP_BOT_URL;
        console.log(botUrl);
        fetch(`${botUrl}/api/unsubscription`, {
            method: "POST",
            mode: "no-cors",
            body: new URLSearchParams({
                userAccountId: user.user_account_id,
                aadid: user.aad_id,
                userName: user.login,
                phoneserviceId: user.phone_service_id,
            }).toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Access-Control-Allow-Origin": "*",
            },
        });
    }

    function getTimestampInSeconds() {
        return Math.floor(Date.now() / 1000);
    }

    async function handleGetContext() {
        console.log("env", process.env.REACT_APP_ENV);
        console.log("context: ", context);
    }

    async function toggleDayPlan() {
        setDayPlanDisableValue(true);
        if (!dayPlanToggleValue) {
            const graphSubscriptionId = await subscribeUserStatus()
            // await saveDayPlan(user.id, graphSubscriptionId)
            user.graph_subscription_id = 123
            setDayPlanToggleValue(true)
        } else {
            await unsubscribeUserStatus(user.graph_subscription_id);
            await removeDayPlan(user.id);
            user.graph_subscription_id = undefined
            setDayPlanToggleValue(false);
        }
        setDayPlanDisableValue(false);
    }

    function handleSendWelcomeMessage() {
        sendWelcomeMessage(user);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Get input values from refs
        const username = usernameInput.current.value;
        const password = passwordInput.current.value;

        const device_id = Math.floor(Math.random() * 100000000000000);
        // console.log("Handle submit " + user.user_account_id + " ps id:" + user.phone_service_id);

        if (user) {
            console.log("refresh user");
            await refreshToken(username, password, device_id);
        } else {
            console.log("log in new");
            await login(username, password, device_id);
        }

        // Clear input values
        console.log(usernameInput);
        if (usernameInput.current) usernameInput.current.value = null;
        if (passwordInput.current) passwordInput.current.value = null;
    };

    const hostName = context?.app?.host?.name;
    const isUnsupportedHost = hostName && !hostName.toLowerCase().includes("teams");

    if (isUnsupportedHost) {
        return (
            <div>
                <div className="position-card-setting">
                    <div className="card" style={{ textAlign: "center", padding: "40px 20px" }}>
                        <h2>Diese App ist nur in Microsoft Teams verfügbar.</h2>
                        <p style={{ marginTop: "12px", color: "#666" }}>
                            Bitte öffnen Sie die ebuero App direkt in Microsoft Teams, um alle Funktionen nutzen zu können.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="position-card-setting">
                <div className="card">
                    {/* <h2>Setting</h2> */}

                    {isInitialize ? (
                        <p>Initialisieren..</p>
                    ) : (
                        <div>
                            {/* <button onClick={handleGetContext}>
                                Get Context
                            </button> */}

                            {(user && user.token !== null) ? (
                                <div>
                                    {/* Header: greeting + sign out */}
                                    <div className="card-header">
                                        <div className="card-header-left">
                                            <div className="user-avatar">
                                                {(user.firstname?.[0] || '').toUpperCase()}{(user.lastname?.[0] || '').toUpperCase()}
                                            </div>
                                            <div className="user-info">
                                                <h2 className="user-name">{user.firstname} {user.lastname}</h2>
                                                <span className="user-login">{user.login}</span>
                                            </div>
                                        </div>
                                        <span onClick={() => setShowSignOutConfirm(true)} className="sign-out-link">Abmelden</span>
                                    </div>

                                    {/* Sign-out confirmation dialog */}
                                    {showSignOutConfirm && (
                                        <div className="sign-out-confirm-overlay" onClick={() => setShowSignOutConfirm(false)}>
                                            <div className="sign-out-confirm-dialog" onClick={e => e.stopPropagation()}>
                                                <h3>Abmelden</h3>
                                                <p>Möchten Sie sich wirklich abmelden?</p>
                                                <div className="sign-out-confirm-actions">
                                                    <button className="btn-cancel" onClick={() => setShowSignOutConfirm(false)}>Abbrechen</button>
                                                    <button className="btn-confirm-signout" onClick={() => { setShowSignOutConfirm(false); signOut(); }}>Abmelden</button>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Feature 1: Call Notes & Chat */}
                                    <div className="feature-section">
                                        <h3 className="feature-title">Anrufnotizen & Chat</h3>
                                        <p className="feature-description">
                                            Mit der App können Sie Anrufnotizen in Ihrem Microsoft Teams Chat erhalten und in Echtzeit mit unserem Kundenservice chatten.
                                        </p>
                                        <p className="feature-description feature-note">
                                            Die ebuero Microsoft Teams App kann nur in Verbindung mit einem laufenden Kundenverhältnis bei der ebuero AG genutzt werden.
                                        </p>
                                        {user.call_note_webhook_id == null ? (
                                            <div>
                                                {isDisabledSubscribe ? (
                                                    <div className="card-processing">
                                                        <span>Wird bearbeitet..</span>
                                                    </div>
                                                ) : (
                                                    <div onClick={subscribeCallNote} className="card-checked">
                                                        <span>Anrufnotizen abonnieren</span>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div>
                                                {isDisabledUnsubscribe ? (
                                                    <div className="card-processing">
                                                        <span>Wird bearbeitet..</span>
                                                    </div>
                                                ) : (
                                                    <div onClick={unsubscribeCallNote} className="card-check">
                                                        <span>Anrufnotizen abbestellen</span>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {/* Feature 2: Employee Sync & Presence */}
                                    <div className="feature-section">
                                        <h3 className="feature-title">Mitarbeiterliste & Verfügbarkeit</h3>
                                        <p className="feature-description">
                                            Verbinden Sie Ihre Microsoft Teams Benutzer mit ebuero. Diese Funktion synchronisiert zwei Bereiche:
                                        </p>
                                        <ul className="feature-list">
                                            <li>
                                                <strong>Mitarbeiterliste synchronisieren</strong> — Ihre Teams-Benutzer (Namen, E-Mail-Adressen, Jobtitel) werden automatisch in Ihre ebuero-Mitarbeiterliste importiert. Ihr Sekretariat hat immer aktuelle Kontaktdaten ohne manuelle Eingabe.
                                            </li>
                                            <li>
                                                <strong>Live-Verfügbarkeitsstatus</strong> — Der Teams-Status Ihrer Mitarbeiter (Verfügbar, Beschäftigt, In einem Anruf usw.) wird in Echtzeit angezeigt, damit Ihr Sekretariat weiß, wer gerade erreichbar ist.
                                            </li>
                                        </ul>

                                        <div className="status-indicators">
                                            <SyncStatusPill value={syncStatus} />
                                            <PresenceStatusPill value={presenceStatus} />
                                        </div>

                                        <div style={{ textAlign: 'center' }}>
                                            {ssoLoading ? (
                                                <div className="card-processing">
                                                    <span>Verbindung wird hergestellt...</span>
                                                </div>
                                            ) : (
                                                <div onClick={async () => {
                                                    try {
                                                        // OBO may silently return a reduced-scope token when partial
                                                        // consent exists (no consent_required raised). Verify the scp
                                                        // claim before treating silent success as final.
                                                        const result = await ssoLogin(SSO_SCOPES);
                                                        const fullyConsented = result && result.accessToken
                                                            && hasAllScopes(result.accessToken, REQUIRED_GRAPH_SCOPES);

                                                        if (result && !result.needsConsent && fullyConsented) {
                                                            history.push('/sync');
                                                            return;
                                                        }

                                                        // Escalate to the Teams auth popup within the same click.
                                                        const consentResult = await ssoLoginWithConsent(SSO_SCOPES);
                                                        if (consentResult && !consentResult.needsConsent
                                                            && hasAllScopes(consentResult.accessToken, REQUIRED_GRAPH_SCOPES)) {
                                                            history.push('/sync');
                                                        }
                                                    } catch (e) {
                                                        console.error('SSO Interaction error:', e);
                                                    }
                                                }} className="card-checked" style={{ backgroundColor: '#2b5797', cursor: 'pointer' }}>
                                                    <span>Mitarbeiter & Verfügbarkeit verwalten</span>
                                                </div>
                                            )}
                                            {ssoError && <div style={{ color: '#a4262c', fontSize: '12px', marginTop: '8px', textAlign: 'left' }}>{ssoError}</div>}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="login-split">
                                    <div className="login-form-panel">
                                        <h3 className="login-form-title">Anmeldung</h3>
                                        <form onSubmit={handleSubmit}>
                                            <label className="login-label">ebuero-Login</label>
                                            <input
                                                type="text"
                                                ref={usernameInput}
                                                className="input-setting"
                                            />
                                            <label className="login-label">Passwort</label>
                                            <input
                                                type="password"
                                                ref={passwordInput}
                                                className="input-setting"
                                            />
                                            <div style={{ marginTop: '20px' }}>
                                                {loading ? (
                                                    <button className="btn-login-loading" style={{ width: '100%' }}>Wird geladen..</button>
                                                ) : (
                                                    <button type="submit" className="btnLogin" style={{ width: '100%', padding: '12px 0' }}>Anmeldung</button>
                                                )}
                                            </div>
                                            {infoloading && (
                                                <p className="login-error-info">
                                                    Die ebuero Microsoft Teams App kann nur in Verbindung mit einem laufenden Kundenverhältnis bei der ebuero AG genutzt werden.
                                                    Falls Sie noch kein Kunde sind, können Sie gerne unseren Telefonservice 14 Tage kostenfrei nutzen.
                                                    <a href="https://www.ebuero.de/telefonservice/demo" target="_blank" rel="noopener noreferrer"> Demo anfordern</a>
                                                </p>
                                            )}
                                        </form>
                                    </div>
                                    <div className="login-hero">
                                        <h2 className="login-hero-title">ebuero Microsoft Teams App</h2>
                                        <p className="login-hero-desc">
                                            Loggen Sie sich hier ein, um Ihre ebuero App mit Microsoft Teams zu verbinden. Lesen Sie Ihre Anrufnotizen, chatten Sie mit unserem Kundenservice und synchronisieren Sie Ihre Mitarbeiterliste — alles direkt in Teams.
                                        </p>
                                        <div className="login-hero-features">
                                            <div className="login-hero-feature">
                                                <span className="login-hero-feature-icon">&#9993;</span>
                                                <div>
                                                    <strong>Anrufnotizen erhalten</strong>
                                                    <span className="login-hero-feature-desc">Neue Anrufnotizen direkt im Teams-Chat lesen</span>
                                                </div>
                                            </div>
                                            <div className="login-hero-feature">
                                                <span className="login-hero-feature-icon">&#128172;</span>
                                                <div>
                                                    <strong>Live-Chat mit Kundenservice</strong>
                                                    <span className="login-hero-feature-desc">In Echtzeit mit unserem Team chatten</span>
                                                </div>
                                            </div>
                                            <div className="login-hero-feature">
                                                <span className="login-hero-feature-icon">&#8644;</span>
                                                <div>
                                                    <strong>Mitarbeiter-Sync</strong>
                                                    <span className="login-hero-feature-desc">Teams-Benutzer und Verfügbarkeit automatisch synchronisieren</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Setting;